module.exports = __webpack_public_path__ + "static/media/chomley 6.250ddc59.jpg";